import { render, staticRenderFns } from "./eduInfo.vue?vue&type=template&id=86188700&scoped=true"
import script from "./eduInfo.vue?vue&type=script&lang=js"
export * from "./eduInfo.vue?vue&type=script&lang=js"
import style0 from "./eduInfo.vue?vue&type=style&index=0&id=86188700&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86188700",
  null
  
)

export default component.exports